import * as api from "../../api/apiConnector.js";

const folder_selector_widget = async (params) => {
    const { container, parentId, currentFolderId, user, item, onClick } = params;

    const _getFolder_data = async ({ parentId }) => {
        var result = await api.sendMessage("dms/getFolder", {
            user,
            body: {
                id: parentId
            }
        });

        return result?.content?.folders ?? [];
    }

    const _drawUL = async ({ container, parentId, level = 0, item }) => {
        const ul = window.$(`<ul class="text-small" />`);
        container.append(ul);
        if (level > 0) {
            ul.css("margin-left", `${level}em`);
        }

        var data = await _getFolder_data({ parentId });


        window.$.each(data, async (infex, f) => {

            let sqMinus = window.$(`<svg width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`);

            let sqPlus = window.$(`<svg width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 8V16M8 12H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`);

            let sqPlusDisabled = window.$(`<svg width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 8V16M8 12H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" stroke="#dedede" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`);

            let li = window.$(`<li class="" />`);
            let expand = window.$(`<span/>`);
            li.append(expand);
            li.append(` `);
            let span = window.$(`<span />`).text(f.Name);
            span.css("cursor", "pointer");
            span.on("dblclick", (e) => {
                if (onClick) {
                    onClick(f, item);
                }
            });
            li.append(span);
            expand.append(sqPlus);

            let waiting = window.$(`<div class="text-center"><svg width="5em" version="1.1" id="L7" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
 <path fill="#000" d="M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3
  c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z">
      <animateTransform 
         attributeName="transform" 
         attributeType="XML" 
         type="rotate"
         dur="2s" 
         from="0 50 50"
         to="360 50 50" 
         repeatCount="indefinite" />
  </path>
 <path fill="#000" d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7
  c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z">
      <animateTransform 
         attributeName="transform" 
         attributeType="XML" 
         type="rotate"
         dur="1s" 
         from="0 50 50"
         to="-360 50 50" 
         repeatCount="indefinite" />
  </path>
 <path fill="#000" d="M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5
  L82,35.7z">
      <animateTransform 
         attributeName="transform" 
         attributeType="XML" 
         type="rotate"
         dur="2s" 
         from="0 50 50"
         to="360 50 50" 
         repeatCount="indefinite" />
  </path>
</svg>
</div>`);

            expand.on("click", async (e) => {
                if (!li.attr("data-expanded")) {
                    if (li.find("ul").length === 0) {
                        li.append(waiting);
                        let _data = await _drawUL({ container: li, parentId: f.Id, level: level + 1, item: item });
                        waiting.remove();
                        expand.html("");
                        if (_data && _data.length > 0) {
                            expand.append(sqMinus);
                        }
                        else {
                            expand.append(sqPlusDisabled);
                            li.attr("data-disabled", true);
                        }
                    }
                    else {
                        li.find("ul").first().show();
                        expand.html("");
                        if (li.attr("data-disabled")) {
                            expand.append(sqPlusDisabled);
                        }
                        else {
                            expand.append(sqMinus);
                        }
                        li.attr("data-expanded", true);
                    }
                } else {
                    li.find("ul").first().hide();
                    expand.html("");
                    expand.append(sqPlus);
                    li.attr("data-expanded", null);
                }
            });

            if (f.Id !== item.item.Id) {

                ul.append(li);
            }
            else {
                var t = 1;
            }
        });

        return data;
    }

    container.html("");
    await _drawUL({ container, parentId, item });
}

export { folder_selector_widget }